import styled from 'styled-components';
import { colorTokens } from '../../../../../tokens/globals/tokens';

const SiteKitLocalNav = styled.div`
  border-bottom: 1px solid ${colorTokens.GlobalBrandGray30};
  padding: 0 20px;
  width: 100%;

  & > nav {
    box-shadow: none;
  }
`;

SiteKitLocalNav.displayName = 'SiteKit.LocalNav';

export { SiteKitLocalNav };
